(() => {
  const message = 'Online ordering is paused. Please contact us to order.';
  const selector = '[name="add"], .quick-add__submit';
  let hintId = 0;
  function lockControls(root = document) {
    root.querySelectorAll(selector).forEach((button) => {
      if (!button.disabled) button.disabled = true;
      if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
      if (button.parentElement.classList.contains('tmp-ordering-disabled')) return;
      const wrapper = document.createElement('span');
      wrapper.className = 'tmp-ordering-disabled';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'group');
      wrapper.setAttribute('aria-label', 'Online ordering unavailable');
      const hint = document.createElement('span');
      hint.className = 'tmp-ordering-disabled__hint';
      hint.id = `tmp-ordering-hint-${++hintId}`;
      hint.textContent = message;
      wrapper.setAttribute('aria-describedby', hint.id);
      button.before(wrapper);
      wrapper.append(button, hint);
    });
    root.querySelectorAll('quick-add-bulk input, quick-add-bulk button, quick-order-list input, quick-order-list button').forEach((control) => {
      if (!control.disabled) control.disabled = true;
      if (control.title !== message) control.title = message;
    });
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('[data-type="add-to-cart-form"]') || /\/cart\/add(?:\.js)?(?:\?|$)/.test(form.action)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest(selector + ', .tmp-ordering-disabled, quick-add-bulk, quick-order-list')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  lockControls();
  new MutationObserver(() => lockControls()).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled']
  });
})();
